"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ActivityTimeline;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ul = _interopRequireDefault(require("./styled/ul"));

/**
 * The ActivityTimeline displays each of any item upcoming, current, and past activities.
 * @category Layout
 */
function ActivityTimeline(props) {
  var children = props.children,
      className = props.className,
      style = props.style;
  return /*#__PURE__*/_react["default"].createElement(_ul["default"], {
    className: className,
    style: style
  }, children);
}

ActivityTimeline.propTypes = {
  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object]),

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
ActivityTimeline.defaultProps = {
  children: null,
  className: undefined,
  style: undefined
};